import { render } from "./ApplicantComments.vue?vue&type=template&id=4e81aa66&scoped=true"
import script from "./ApplicantComments.vue?vue&type=script&lang=js"
export * from "./ApplicantComments.vue?vue&type=script&lang=js"

import "./ApplicantComments.vue?vue&type=style&index=0&id=4e81aa66&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e81aa66"]])

export default __exports__